// extracted by mini-css-extract-plugin
export default {"mainSection":"Header_mainSection__Am-3m","Text":"Header_Text__7+fUs","title":"Header_title__1AD+t","titleLine":"Header_titleLine__XqU-Y"};